module.exports = __webpack_public_path__ + "media/images/pic/cake-9cc0e43b921e917c73b50c2c58c10b17.svg";